
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91file_id_93niwbVLZeXPnlwv4Gkwgxsf1bhJGEtLEHZferc8AGTfwMeta } from "/tmp/build_ebc17ae8/pages/all/[file_id].vue?macro=true";
import { default as allRwqesLTVLFIfMjggT9gus9mG1hwFxkaZk6xF4FxjXnUMeta } from "/tmp/build_ebc17ae8/pages/all.vue?macro=true";
import { default as indexPAMkVPTZE39xMmjuSVHWC5oVYZamMy5kkBdOL_iSa3sMeta } from "/tmp/build_ebc17ae8/pages/home/index.vue?macro=true";
import { default as _91file_id_93SetZxDvYF1choQ_21wKR8TwZ18gAFX12Pj4V8HHpjfgMeta } from "/tmp/build_ebc17ae8/pages/home/on-this-day/files/[file_id].vue?macro=true";
import { default as on_45this_45dayhnxycgYcIAKr9_R2HCmrWmoPJGv6Nwk_45j_cranBZFNUMeta } from "/tmp/build_ebc17ae8/pages/home/on-this-day.vue?macro=true";
import { default as _91file_id_93RUewRDiNwZAWktbuUXTwZ9LsTRKLCz5NksHV26vQzgkMeta } from "/tmp/build_ebc17ae8/pages/home/recent-days/files/[file_id].vue?macro=true";
import { default as recent_45daysmPmtKZKf9KubzMKa2xXIY5D5vbF4gdRd1VyYCWMXc9EMeta } from "/tmp/build_ebc17ae8/pages/home/recent-days.vue?macro=true";
import { default as _91file_id_93cHY94PJrqUzykn45UddnfaZIUSwiN1nRQAJMNOfLD6sMeta } from "/tmp/build_ebc17ae8/pages/home/favorites/[file_id].vue?macro=true";
import { default as homewQgdkMV21grA3jvfEXI526NmW6fbH_458vpLEg80GUxXYMeta } from "/tmp/build_ebc17ae8/pages/home.vue?macro=true";
import { default as indexKgY5KWGsO8rW1UIRJ76dbEBAwRKfghQdlwWYGMIebjQMeta } from "/tmp/build_ebc17ae8/pages/index.vue?macro=true";
import { default as galleryFVYRnJs4hi1UPYABaHAjTpD4tKcp7uhubDUGbUOg5cYMeta } from "/tmp/build_ebc17ae8/pages/gallery.vue?macro=true";
import { default as sign_inzyhLPCmqule_y2LEr0NRHr3cl7f2d4NbN9Dk67wvIL8Meta } from "/tmp/build_ebc17ae8/pages/sign_in.vue?macro=true";
import { default as welcomeo_2OrSTqXG_45EMUbHBp7OO7MjZjhPBRxFSTkY9Gnc_45HwMeta } from "/tmp/build_ebc17ae8/pages/welcome.vue?macro=true";
import { default as projects_vwn1HHZcTHa5uy30Z8tFPfW0qX9TJeIVAwzfctrPwoMeta } from "/tmp/build_ebc17ae8/pages/projects.vue?macro=true";
import { default as index0abLuVdlnxDnc57LmBheom70_451ZXT4o6qh56MUutv_45QMeta } from "/tmp/build_ebc17ae8/pages/groups/index.vue?macro=true";
import { default as indexQpdBfGq9q4F_457yhXxBhnH8Mp2Ku4GP6irttEQdy6bJQMeta } from "/tmp/build_ebc17ae8/pages/delete-bin/index.vue?macro=true";
import { default as index6mr8OHClu9EoMlrVG3vxmrr15TrVksmmkhPPHvmdfycMeta } from "/tmp/build_ebc17ae8/pages/connections/index.vue?macro=true";
import { default as _91_91id_93_93eV0gOZuT5O1MZmgF4yACMafPxHlArpGPdMZUBwElOu0Meta } from "/tmp/build_ebc17ae8/pages/impersonate/[[id]].vue?macro=true";
import { default as index8act76xj33iBI7XnrdHAAARsALuwivkkqYoUXN43acYMeta } from "/tmp/build_ebc17ae8/pages/notifications/index.vue?macro=true";
import { default as indexdSmoUrlZxHbcg09_454dJAD9kCPPfLMurjgYm16mGETW4Meta } from "/tmp/build_ebc17ae8/pages/digitization-projects/index.vue?macro=true";
import { default as _91_91token_93_93S_45TYkw5nqliLIzDAEHIaOp_45VtA6uvqhAFCQz57zxAV8Meta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/[[token]].vue?macro=true";
import { default as indexcgyOohk38Ko5QNprxUE5kkna7i5isXlepQRvVcwRRH4Meta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/tags/index.vue?macro=true";
import { default as indexuftpD0IiMEzrpbX1QmXAXyma2S61otCZmpHc1ZVTMEUMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/index.vue?macro=true";
import { default as indexx2PUkLEAC2Ksztnu_ysMqoZJBXWJ4fkppnKE67nkQTsMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/people/index.vue?macro=true";
import { default as recentGVTGTvyOhv_bckphNtqp4dyPokj9_gXnJ9sXeHBXGMMMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/recent.vue?macro=true";
import { default as visited85_zrD23gI8mPzClH1EqnJvPdglF8JAxjTtR8A0CWJ4Meta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/visited.vue?macro=true";
import { default as _91file_id_930hxv_45XSIsRM18w8CAd9prgQAUrErhQ7KXOsYgIOmv00Meta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/print-projects/[file_id].vue?macro=true";
import { default as print_45projects_45mts8tMTiKRU00nIrlQSGuQbG8Lb3eCTrLGWB_45k_RPcMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/print-projects.vue?macro=true";
import { default as indexN_45WfgtF4g4YxF1VuwR6VJ0VTippfmjomKL6Jz17D7YwMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/timeline/index.vue?macro=true";
import { default as _91file_id_932_45JhKSE_45NgY_BM2_45nWr8LDtheATIqHzsHK3Bd7OfNDQMeta } from "/tmp/build_ebc17ae8/pages/digitization-projects/[box_id]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93_Y6LScN1Z4fIQ_45FFPXusCwcMGWZ7h8LXxYWM23F6Y_AMeta } from "/tmp/build_ebc17ae8/pages/digitization-projects/[box_id]/[[share_token]].vue?macro=true";
import { default as _91share_token_93KxFxYygLRRWlOe8QBA_Y1tFRz4G3jlaS3L4_45r38py1sMeta } from "/tmp/build_ebc17ae8/pages/external/embed/[user_id]/[file_id]/[share_token].vue?macro=true";
import { default as _91file_id_93BRYLlIBwL_45vlcUeebA0o4JFmE9pvvyjQsf_45zWeinVsYMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/timeline/period/[period_id]/file/[file_id].vue?macro=true";
import { default as _91period_id_933DvD_45kWOD2Q50kA6XCXJphkhP5NDATnoSaVmdN8QXfkMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/timeline/period/[period_id].vue?macro=true";
import { default as _91_91share_token_93_93vvGheZa2L0OXGqLv1GlY5U0fPFhef9O107_z5somrFgMeta } from "/tmp/build_ebc17ae8/pages/digitization-projects/files/[file_id]/[[share_token]].vue?macro=true";
import { default as _91_91share_token_93_93nzCqg54iZqkFhZ3wg16xD0sTspstpbAJ_rRIECMD0AUMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/files/[file_id]/[[share_token]].vue?macro=true";
import { default as _91file_id_93ToqHDqtjql5wQuf69JasAhNHSzYfFN5NZ_45eL_wRB3hMMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93tVdLyhEfZ82PiPB_qiMEGBwkZcYtf9RJCHstTF59nxQMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]].vue?macro=true";
import { default as _91file_id_93Ryqw9hqYUu7YEX3XEaVAfAzsoruV21HAuGGBuK1h3_8Meta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93NhF8rp_WRUz5HR1DOQwCKpMrYagO88zZmIUn6HDprnoMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]].vue?macro=true";
import { default as _91file_id_93EGInoYpHt5mCVsGW1tCMgeeCjSw2b0cXGXYyB9emDS0Meta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93rqTuak03Icwg_Ml6HlX9QU1_JfKTOC04Cy3QsLd_mxIMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]].vue?macro=true";
import { default as _91file_id_93XY_e814a21yNP796O11HfPgWafud_DMZ_uVB_45YRmS3kMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_939dXHGVXBDLyiotsQhNMi1GFrYhXBtaCyHwtNm5dieUUMeta } from "/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]].vue?macro=true";
import { default as component_45stubiv8KRlYCq5mnMtAOqwHaoH3zssdL_45KY8RyL8om73ipYMeta } from "/tmp/build_ebc17ae8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubiv8KRlYCq5mnMtAOqwHaoH3zssdL_45KY8RyL8om73ipY } from "/tmp/build_ebc17ae8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "all",
    path: "/all",
    meta: allRwqesLTVLFIfMjggT9gus9mG1hwFxkaZk6xF4FxjXnUMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/all.vue"),
    children: [
  {
    name: "all-file_id",
    path: ":file_id()",
    meta: _91file_id_93niwbVLZeXPnlwv4Gkwgxsf1bhJGEtLEHZferc8AGTfwMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/all/[file_id].vue")
  }
]
  },
  {
    name: homewQgdkMV21grA3jvfEXI526NmW6fbH_458vpLEg80GUxXYMeta?.name,
    path: "/engage",
    meta: homewQgdkMV21grA3jvfEXI526NmW6fbH_458vpLEg80GUxXYMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/home.vue"),
    children: [
  {
    name: "home",
    path: "",
    component: () => import("/tmp/build_ebc17ae8/pages/home/index.vue")
  },
  {
    name: "home-on-this-day",
    path: "on-this-day",
    component: () => import("/tmp/build_ebc17ae8/pages/home/on-this-day.vue"),
    children: [
  {
    name: "home-on-this-day-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93SetZxDvYF1choQ_21wKR8TwZ18gAFX12Pj4V8HHpjfgMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/home/on-this-day/files/[file_id].vue")
  }
]
  },
  {
    name: "home-recent-days",
    path: "recent-days",
    component: () => import("/tmp/build_ebc17ae8/pages/home/recent-days.vue"),
    children: [
  {
    name: "home-recent-days-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93RUewRDiNwZAWktbuUXTwZ9LsTRKLCz5NksHV26vQzgkMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/home/recent-days/files/[file_id].vue")
  }
]
  },
  {
    name: "home-favorites-file_id",
    path: "favorites/:file_id()",
    meta: _91file_id_93cHY94PJrqUzykn45UddnfaZIUSwiN1nRQAJMNOfLD6sMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/home/favorites/[file_id].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexKgY5KWGsO8rW1UIRJ76dbEBAwRKfghQdlwWYGMIebjQMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/index.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/tmp/build_ebc17ae8/pages/gallery.vue")
  },
  {
    name: "sign_in",
    path: "/sign_in",
    meta: sign_inzyhLPCmqule_y2LEr0NRHr3cl7f2d4NbN9Dk67wvIL8Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/sign_in.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeo_2OrSTqXG_45EMUbHBp7OO7MjZjhPBRxFSTkY9Gnc_45HwMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/welcome.vue")
  },
  {
    name: "projects",
    path: "/projects",
    meta: projects_vwn1HHZcTHa5uy30Z8tFPfW0qX9TJeIVAwzfctrPwoMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/projects.vue")
  },
  {
    name: "groups",
    path: "/groups",
    meta: index0abLuVdlnxDnc57LmBheom70_451ZXT4o6qh56MUutv_45QMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/groups/index.vue")
  },
  {
    name: "delete-bin",
    path: "/delete-bin",
    meta: indexQpdBfGq9q4F_457yhXxBhnH8Mp2Ku4GP6irttEQdy6bJQMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/delete-bin/index.vue")
  },
  {
    name: "connections",
    path: "/connections",
    meta: index6mr8OHClu9EoMlrVG3vxmrr15TrVksmmkhPPHvmdfycMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/connections/index.vue")
  },
  {
    name: "impersonate-id",
    path: "/impersonate/:id?",
    meta: _91_91id_93_93eV0gOZuT5O1MZmgF4yACMafPxHlArpGPdMZUBwElOu0Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/impersonate/[[id]].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: index8act76xj33iBI7XnrdHAAARsALuwivkkqYoUXN43acYMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/notifications/index.vue")
  },
  {
    name: "digitization-projects",
    path: "/digitization-projects",
    meta: indexdSmoUrlZxHbcg09_454dJAD9kCPPfLMurjgYm16mGETW4Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/digitization-projects/index.vue")
  },
  {
    name: "users-user_id_or_slug-token",
    path: "/users/:user_id_or_slug()/:token?",
    meta: _91_91token_93_93S_45TYkw5nqliLIzDAEHIaOp_45VtA6uvqhAFCQz57zxAV8Meta || {},
    alias: ["/invite/:user_id_or_slug()/:token?"],
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/[[token]].vue")
  },
  {
    name: "users-user_id_or_slug-tags",
    path: "/users/:user_id_or_slug()/tags",
    meta: indexcgyOohk38Ko5QNprxUE5kkna7i5isXlepQRvVcwRRH4Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/tags/index.vue")
  },
  {
    name: "users-user_id_or_slug-albums",
    path: "/users/:user_id_or_slug()/albums",
    meta: indexuftpD0IiMEzrpbX1QmXAXyma2S61otCZmpHc1ZVTMEUMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/index.vue")
  },
  {
    name: "users-user_id_or_slug-people",
    path: "/users/:user_id_or_slug()/people",
    meta: indexx2PUkLEAC2Ksztnu_ysMqoZJBXWJ4fkppnKE67nkQTsMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/people/index.vue")
  },
  {
    name: "users-user_id_or_slug-albums-recent",
    path: "/users/:user_id_or_slug()/albums/recent",
    meta: recentGVTGTvyOhv_bckphNtqp4dyPokj9_gXnJ9sXeHBXGMMMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/recent.vue")
  },
  {
    name: "users-user_id_or_slug-albums-visited",
    path: "/users/:user_id_or_slug()/albums/visited",
    meta: visited85_zrD23gI8mPzClH1EqnJvPdglF8JAxjTtR8A0CWJ4Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/visited.vue")
  },
  {
    name: "users-user_id_or_slug-print-projects",
    path: "/users/:user_id_or_slug()/print-projects",
    meta: print_45projects_45mts8tMTiKRU00nIrlQSGuQbG8Lb3eCTrLGWB_45k_RPcMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/print-projects.vue"),
    children: [
  {
    name: "users-user_id_or_slug-print-projects-file_id",
    path: ":file_id()",
    meta: _91file_id_930hxv_45XSIsRM18w8CAd9prgQAUrErhQ7KXOsYgIOmv00Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/print-projects/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-timeline",
    path: "/users/:user_id_or_slug()/timeline",
    meta: indexN_45WfgtF4g4YxF1VuwR6VJ0VTippfmjomKL6Jz17D7YwMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/timeline/index.vue")
  },
  {
    name: "digitization-projects-box_id-share_token",
    path: "/digitization-projects/:box_id()/:share_token?",
    component: () => import("/tmp/build_ebc17ae8/pages/digitization-projects/[box_id]/[[share_token]].vue"),
    children: [
  {
    name: "digitization-projects-box_id-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_932_45JhKSE_45NgY_BM2_45nWr8LDtheATIqHzsHK3Bd7OfNDQMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/digitization-projects/[box_id]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "external-embed-user_id-file_id-share_token",
    path: "/external/embed/:user_id()/:file_id()/:share_token()",
    component: () => import("/tmp/build_ebc17ae8/pages/external/embed/[user_id]/[file_id]/[share_token].vue")
  },
  {
    name: "users-user_id_or_slug-timeline-period-period_id",
    path: "/users/:user_id_or_slug()/timeline/period/:period_id()",
    meta: _91period_id_933DvD_45kWOD2Q50kA6XCXJphkhP5NDATnoSaVmdN8QXfkMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/timeline/period/[period_id].vue"),
    children: [
  {
    name: "users-user_id_or_slug-timeline-period-period_id-file-file_id",
    path: "file/:file_id()",
    meta: _91file_id_93BRYLlIBwL_45vlcUeebA0o4JFmE9pvvyjQsf_45zWeinVsYMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/timeline/period/[period_id]/file/[file_id].vue")
  }
]
  },
  {
    name: "digitization-projects-files-file_id-share_token",
    path: "/digitization-projects/files/:file_id()/:share_token?",
    meta: _91_91share_token_93_93vvGheZa2L0OXGqLv1GlY5U0fPFhef9O107_z5somrFgMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/digitization-projects/files/[file_id]/[[share_token]].vue")
  },
  {
    name: "users-user_id_or_slug-files-file_id-share_token",
    path: "/users/:user_id_or_slug()/files/:file_id()/:share_token?",
    meta: _91_91share_token_93_93nzCqg54iZqkFhZ3wg16xD0sTspstpbAJ_rRIECMD0AUMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/files/[file_id]/[[share_token]].vue")
  },
  {
    name: "users-user_id_or_slug-tags-tag_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/tags/:tag_id_or_slug()/:share_token?",
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-tags-tag_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93ToqHDqtjql5wQuf69JasAhNHSzYfFN5NZ_45eL_wRB3hMMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-albums-album_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/albums/:album_id_or_slug()/:share_token?",
    meta: _91_91share_token_93_93NhF8rp_WRUz5HR1DOQwCKpMrYagO88zZmIUn6HDprnoMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-albums-album_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93Ryqw9hqYUu7YEX3XEaVAfAzsoruV21HAuGGBuK1h3_8Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-people-person_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/people/:person_id_or_slug()/:share_token?",
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-people-person_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93EGInoYpHt5mCVsGW1tCMgeeCjSw2b0cXGXYyB9emDS0Meta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-containers-container_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/containers/:container_id_or_slug()/:share_token?",
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-containers-container_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93XY_e814a21yNP796O11HfPgWafud_DMZ_uVB_45YRmS3kMeta || {},
    component: () => import("/tmp/build_ebc17ae8/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: component_45stubiv8KRlYCq5mnMtAOqwHaoH3zssdL_45KY8RyL8om73ipYMeta?.name,
    path: "/library",
    component: component_45stubiv8KRlYCq5mnMtAOqwHaoH3zssdL_45KY8RyL8om73ipY
  },
  {
    name: component_45stubiv8KRlYCq5mnMtAOqwHaoH3zssdL_45KY8RyL8om73ipYMeta?.name,
    path: "/static/images/forever-album-no-cover.png",
    component: component_45stubiv8KRlYCq5mnMtAOqwHaoH3zssdL_45KY8RyL8om73ipY
  }
]